//prettier-ignore
export default {
  translations: {
    "Initialization": "Initialisatie…",

    //--------------------

    // Page Login
    "_LOGIN_INDEX_TITLE": "Je afspraken en activeringen beheren",
    "_LOGIN_INDEX_INTRODUCTION": "Hier moet je zijn om je afspraken te beheren of een nieuwe TV Box te activeren.",
    "_LOGIN_INDEX_MAIN_DESCRIPTION": "Log in met de persoonlijke code in de mail die we je gestuurd hebben om je bestelling te bevestigen. Let op: je moet je TV Box in ontvangst genomen hebben om hem te kunnen activeren.",
    "_LOGIN_INDEX_DESIRED_ACTION": "Wat wil je doen?",
    "_LOGIN_INDEX_PERSONAL_CODE": "Vul de 8 karakters van je persoonlijke code in",
    "_LOGIN_INDEX_ACTION_MODIFY_APPOINTMENT": "mijn afspraak wijzigen",
    "_LOGIN_INDEX_ACTION_ACTIVATE_STB": "mijn TV Box activeren",
    "_LOGIN_INDEX_LOGIN_BUTTON": "Aanmelden",
    "_LOGIN_INDEX_RESET_CODE_LINK": "Kunt u uw persoonlijke code niet vinden?",
    //// Hey translation
    "_HEY_LOGIN_INDEX_TITLE": "Maak een nieuwe afspraak met onze technicus",
    "_HEY_LOGIN_INDEX_INTRODUCTION": "Op dit portaal kan je een afspraak wijzigen",
    "_HEY_LOGIN_INDEX_MAIN_DESCRIPTION": "Je hebt een sms en/of mail ontvangen met een code van 8 karakters die je hier moet invullen",
    "_HEY_LOGIN_INDEX_INPUT_PLACEHOLDER": "Jouw persoonlijke code...",
    "_HEY_LOGIN_INDEX_LOGIN_BUTTON": "Go!",
    "_HEY_LOGIN_INDEX_RESET_CODE_LINK": "Is je code nergens te vinden? Klik hier.",

    // Page Login WS Errors
    "_LOGIN_INDEX_ERROR_REQUIRED_ACTION": "Kies welke actie u wilt ondernemen",
    "_LOGIN_INDEX_ERROR_REQUIRED_LOGIN": "Vul je persoonlijke code in om je aan te melden",
    "_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_LOGIN": "De code is te lang. Vul de 8 karakters van je persoonlijke code in.",
    "_LOGIN_INDEX_ERROR_OCCURRED": "Er ging iets verkeerd bij het aanmelden.",
    "_LOGIN_INDEX_ERROR_RESET_CODE_LINK": "Vraag een nieuwe persoonlijke code",
    "_LOGIN_INDEX_ERROR_CALLING_NUMBER": "of bel 5000.",
    //// Hey translation
    "_HEY_LOGIN_INDEX_ERROR_REQUIRED_LOGIN": "Je bent vergeten de code in te vullen !",
    "_HEY_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_TOO_SHORT_LOGIN": "De code is te kort. Vul de 8 karakters van je persoonlijke code in.",
    "_HEY_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_TOO_LONG_LOGIN": "De code is te lang. Vul de 8 karakters van je persoonlijke code in.",
    "_HEY_LOGIN_INDEX_ERROR_OCCURRED": "Helaas, er ging iets fout.",
    "_HEY_LOGIN_INDEX_ERROR_RESET_CODE_LINK": "Vraag een nieuwe code aan.",

    //--------------------

    // Page Reset
    "Resend my WeCareID-code": "Vraag je persoonlijke code aan",
    "Please enter your 8-digits customer code over here, and then we will send your WeCareID-code via sms to your mobile.": "Vul je klantnummer in en we zenden je een sms met je persoonlijke code.",
    "If you are already an existing Orange customer, you can find your customer code on your invoice or in your customer zone.": "Je bent Orange klant: je vindt je klantnummer bovenaan links op je factuur of in ‘Mijn profiel’ op je Klantenzone.",
    "If you are a new Love-customer, you can find your customer code on": "Je bent een nieuwe Orange klant: je vindt je klantnummer op de mail die de bestelling van je internet en tv-diensten bevestigt.",
    "Enter your customer-code to retrieve your WeCareID-code": "Vul je klantnummer in",
    "Submit": "Verzenden",
    //// Hey translation
    "_HEY_RESET_TITLE": "Vraag een nieuwe persoonlijke code aan",
    "_HEY_RESET_INDICATION_INTRO": "Vul je hey!-klantnummer in, wij regelen de rest.",
    "_HEY_RESET_INDICATION_OUTRO": "Je ontvangt dadelijk een sms met een nieuwe persoonlijke code.",
    "_HEY_RESET_ALREADY_CUSTOMER": "Al hey!-klant? Je vindt je klantnummer in de linkerbovenhoek van je factuur of op het tabblad \"Mijn profiel\" in My hey!",
    "_HEY_RESET_NEW_CUSTOMER": "Je bestelde zopas bij hey! maar hebt nog geen factuur? Je klantnummer staat in de bevestigingsmail die je ontvangt",
    "_HEY_RESET_INPUT_PLACEHOLDER": "Jouw klantnummer...",
    "_HEY_RESET_NEW_CODE_BUTTON": "Kom maar op met die nieuwe code",
    "_HEY_RESET_HOME_LINK": "Sms ontvangen? Klik hier",

    // Page Reset WS Success
    "Thanks for submitting your customer code. We received your request. Within 1 minute you should receive an sms with your WeCareID-code.": "We hebben je aanvraag goed ontvangen. Je ontvangt zo dadelijk een sms met je persoonlijke code.",
    "If you didn't receive any sms from us, please verify your customer code and try again or call 5000 for support.": "Heb je na enkele minuten geen sms ontvangen, geef dan je klantnummer in en probeer opnieuw of bel naar 5000.",
    "Please copy the code you received in the sms to identify yourself and change your appointment date": "Klik op de knop hieronder om verder te gaan wanneer je de sms hebt ontvangen.",
    "Change my appointment": "Mijn afspraak wijzigen",
    // Page Reset WS Errors
    "Please enter customer code as its required field.": "Vul je klantnummer in om je aan te melden",
    "Please enter maximum 9 character long text including dot.": "Het ingevulde klantnummer is niet correct. Probeer het opnieuw.",
    "Something went wrong in submitting your customer code. Please try again or call 5000 for support.": "Er ging iets verkeerd bij het aanmelden. Vraag opnieuw een persoonlijke code aan of bel 5000.",
    //// Hey translation
    // positive flow
    "_HEY_RESET_REQUEST_SENT": "Aanvraag goed ontvangen! Je ontvangt zo dadelijk een sms met je persoonlijke code.",
    "_HEY_RESET_SMS_NOT_RECEIVED": "Als je na enkele minuten nog steeds geen sms hebt ontvangen, voer je je klantnummer in en probeer je het opnieuw.",
    // negative flow
    "_HEY_RESET_CUSTOMER_CODE_NOT_FOUND": "Het klantnummer is niet juist. Probeer het opnieuw.",
    "_HEY_RESET_CUSTOMER_CODE_NOT_FILLED": "Je bent vergeten je klantnummer in te vullen.",

    //--------------------

    //  Page Appointments
    //"Change my Internet + TV installation date": "Vous devez modifier votre rendez-vous ?",
    "_APPOINTMENT_INDEX_TITLE": "Mijn Internet + TV installatiedatum wijzigen",
    "_APPOINTMENT_WELCOME": "Hallo",
    "_APPOINTMENT_INFOS_REPLAN_DATE": "Hieronder vind je een overzicht van de geplande afspraak (afspraken) voor je Orange-diensten. Je kan hieronder een andere datum kiezen, rekening houdend met de beschikbaarheid van Orange-technici.",
    "Intervention in past, or status Done or status Cancel - not possible to change": "Geannuleerde afspraak of afspraak in het verleden. Kan niet worden gewijzigd.",
    "_OBE_APPOINTMENT_ADD_INFO_CANCEL": "Geannuleerde afspraak of afspraak in het verleden. Wil je een nieuwe afspraak maken, contacteer ons dan op het nummer 5000.",
    "Modify": "Wijzigen",
    "OBE_FIRST_TLN_NONE": "Installatie internet en tv", //a
    "OBE_FIRST_TLN_STREET": "Installatie internet en tv", //b
    "OBE_FIRST_VOO_SINGLE": "Installatie internet en tv", //c
    "OBE_FIRST_TLN_INDOOR_TAP": "Installatie internet en tv", //d
    "OBE_FIRST_VOO_DUAL": "Installatie internet en tv", //e
    "TLN_FIRST_INDOOR_TAP": "Kwaliteitscontrole van de kabelverbinding", //f
    "VOO_FIRST_VOO_DUAL": "Kwaliteitscontrole van de kabelverbinding", // g
    "OBE_INTERVENTION": "Bijkomende installatie", // h
    "OBE_REPAIR": "Herstelling", // i
    "REPAIR_DUO": "Herstelling", // j
    "REPAIR_VOO": "Herstelling", // k
    "REPAIR_TLN": "Herstelling", // l
    "INSTALL_DYI": "Doe-het-zelf installatie", // m
    "MODEM_UPGRADE": "Vervanging van de modem", // n
    "OBE_INTERVENTION_INTERNET": "Bijkomende installatie",
    "OBE_FIRST_INTERNET": "Installatie internet",
    "OBE_FTTH_FIRST": "Installatie Fiber",
    "OBE_FTTH_INTERVENTION": "Bijkomende installatie",
    "OBE_FTTH_REPAIR": "Herstelling",
    "OBE_MOVE_INTERNET": "Verhuis",
    "OBE_MOVE_TLN_NONE": "Verhuis",
    "OBE_MOVE_TLN_STREET": "Verhuis",
    "OBE_MOVE_VOO_SINGLE": "Verhuis",
    "OBE_MOVE_TLN_INDOOR_TAP": "Verhuis",
    "OBE_MOVE_VOO_DUAL": "Verhuis",
    "Appointment": "Afspraak",
    "Planned date": "Geplande datum",
    "Additional information": "Bijkomende informatie",
    "_OBE_APPOINTMENT_ADD_INFO_DONE": "Geannuleerde afspraak of afspraak in het verleden. Kan niet worden gewijzigd.",
    "_OBE_APPOINTMENT_ADD_INFO_PENDING_OR_LOCKED": "Je kan deze afspraak niet zelf wijzigen. Je moet hiervoor de klantendienst bellen op het nummer 5000.",
    //// Hey translation
    "_HEY_APPOINTMENT_INDEX_TITLE": "Wijzig de datum van je internet-installatie",
    "_HEY_APPOINTMENT_INFOS_RETRIEVE_DATE": "Hier vind je geplande afspraak voor de installatie van je internetdienst.",
    "_HEY_APPOINTMENT_INFOS_REPLAN_DATE": "Je kan je afspraak verplaatsen naargelang de beschikbaarheid van de technici.",
    "_HEY_APPOINTMENT_ADD_INFO_PENDING_OR_LOCKED": "Je kan deze afspraak niet zelf wijzigen. Contacteer ons via de chatbot op onze website www.heytelecom.be/nl.",
    "_HEY_APPOINTMENT_ADD_INFO_DONE": "Geannuleerde afspraak of afspraak in het verleden. Kan niet worden gewijzigd.",
    "_HEY_APPOINTMENT_ADD_INFO_CANCEL": "Geannuleerde afspraak of afspraak in het verleden. Wil je een nieuwe afspraak maken, contacteer ons dan via de chatbot op onze website www.heytelecom.be/nl",

    // Modal Appointment
    "_APPOINTMENT_MODAL_CHANGE_DATE": "De afspraak wijzigen",
    "_APPOINTMENT_MODAL_PICK_A_DATE": "Kies een datum",
    "An error occurred. Please call 5000 for support.": "Er ging iets verkeerd. Om hulp de krijgen, moet je de klantendienst bellen op het nummer 5000.",
    //// Hey translation
    "_HEY_APPOINTMENT_MODAL_CHANGE_DATE": "Verplaats je afspraak",
    "_HEY_APPOINTMENT_MODAL_PICK_A_DATE": "Kies een datum",
    "_HEY_APPOINTMENT_MODAL_SUBMIT_BUTTON": "Ik verplaats mijn afspraak",

    "January": "Januari",
    "February": "Februari",
    "March": "Maart",
    "April": "April",
    "May": "Mei",
    "June": "Juni",
    "July": "Juli",
    "August": "Augustus",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "Décember",

    "Mo": "ma.",
    "Tu": "di.",
    "We": "woe.",
    "Th": "do.",
    "Fr": "vrij.",
    "Sa": "za.",
    "Su": "zo.",

    "Monday": "Maandag",
    "Tuesday": "Dinsdag",
    "Wednesday": "Woensdag",
    "Thursday": "Donderdag",
    "Friday": "Vrijdag",
    "Saturday": "Zaterdag",
    "Sunday": "Zondag",

    "_APPOINTMENT_MODAL_SELECT_PREFFERED_TIMING": "Selecteer de timing van uw voorkeur",
    "_HEY_APPOINTMENT_MODAL_SELECT_PREFFERED_TIMING": "Kies een tijdvak",

    "8AM" : "(08:00 - 09:00)",
    "AM": "(8:00 - 12:00)",
    "NOON" : "(10:00 - 15:00)",
    "PM": "(13:00 - 18:00)",
    "EVE": "(18:00 - 20:00)",

    "8AM_full" : "8u (08:00 - 09:00)",
    "AM_full": "Voormiddag (8:00 - 12:00)",
    "NOON_full" : "Middag (10:00 - 15:00)",
    "PM_full": "Namiddag (13:00 - 18:00)",
    "EVE_full": "Avond (18:00 - 20:00)",

    "_APPOINTMENT_MODAL_WARNING": "Afspraken gepland tussen 18 en 20 uur of op zaterdag hebben een bijkomende kost van 30 euro.  Behalve in geval van herstelling onder garantie.  Niet nagekomen afspraak: {{lateCancellationPrice}} € Indien je de afspraak minder dan een dag op voorhand wijzigt of annuleert, nl. na 12u00 de dag ervoor, of indien je niet aanwezig bent op het tijdstip van de afspraak.",
    "_HEY_APPOINTMENT_MODAL_WARNING": "Elke niet nagekomen afspraak zal je {{lateCancellationPrice}} € kosten: als je de afspraak minder dan een dag op voorhand, dus na 12 uur de dag ervoor, annuleert of verplaatst, of als je niet aanwezig bent op de afspraak.",

    // "Submit": "Verzenden",
    "_APPOINTMENT_SUBMIT_CHANGE_DATE_TITLE": "Wijziging van de afspraak",
    "_APPOINTMENT_SUBMIT_MESSAGE": "Je afspraak is gewijzigd. Sluit het venster om terug naar het overzicht te gaan.",
    "Something went wrong in submitting the form and changing the date. Please try again.": "Er is iets fout gegaan. Je afspraak is niet gewijzigd. Probeer het opnieuw.",
    "Close": "Sluiten",
    //// Hey translation
    "_HEY_APPOINTMENT_SUBMIT_CHANGE_DATE_TITLE": "Nieuwe afspraak",
    "_HEY_APPOINTMENT_SUBMIT_MESSAGE": "Je afspraak werd verplaatst. Sluit dit venster om terug te keren naar het overzicht.",
    "_HEY_APPOINTMENT_SUBMIT_BUTTON_CLOSE": "Pop-up sluiten",

    // CGN
    "Disabled my CGN": "CGN uitschakelen",
    "You want to deactivate your CGN": "Je wil je CGN uitschakelen",
    "How to do": "Hoe ga je te werk?",
    "Why the CGN": "Nut van CGN",
    "CGN Impact": "Impact van CGN",
    "_cgn_login_why_cgn_txt_p1": "CGN (Carrier Grade Nating) is een oplossing om het tekort aan IPv4-adressen aan te pakken.",
    "_cgn_login_why_cgn_txt_p2": "Het opzet van deze oplossing is om niet langer een publiek IPv4-adres maar wel een privé-IP-adres aan elke residentiële gebruiker (modem) toe te wijzen. Het CGN-systeem is belast met de taak om de privé-IP-adressen die aan de gebruikers worden toegewezen te koppelen aan het publieke adres dat in realiteit gebruikt wordt om toegang te krijgen tot het internet.",
    "_cgn_login_cgn_impact_txt_p1": "CGN heeft geen waarneembare invloed op de prestaties van je internetverbinding.<br />CGN is compatibel met de meeste internetdiensten. ",
    "_cgn_login_cgn_impact_txt_p2": "CGN heeft wel een impact op die apps en diensten waarvoor een poortopening vereist is.<br />(Bijvoorbeeld: websitehosting, remote access tot een NAS, VPN-hosting, rechtstreekse toegang (zonder cloud) tot geconnecteerde producten bij jou thuis, bepaalde games/spelconsoles).",
    "_cgn_login_cgn_how_todo_txt_p1": "Om te beginnen, meld je aan. Neem de eerste installatiemail erbij, waarin je jouw persoonlijke code vindt. Vind je de code niet of heb je die niet meer? Geen paniek! Klik",
    "_cgn_login_cgn_how_todo_txt_p1_end": "om een nieuwe code te krijgen.",
    "_cgn_login_cgn_how_todo_txt_p1_link": "hier",
    "The CGN at your place": "Le CGN chez vous",
    "_cgn_form_at_you_place_txt_p1": "Om het type IP-adres bij jou thuis te wijzigen of controleren, voer de ID van je modem in (ook wel HFC MAC address genoemd). Die ID vind je in het kadertje op de sticker onderaan op je modem. Meer info",
    "_cgn_form_at_you_place_txt_p1_link":"hier",
    "_cgn_form_at_you_place_txt_p1_end":".",
    "The CGN at your place.": "CGN bij jou thuis",
    "_cgn_form_input_your_modem_id": "Voer de ID van je modem in",
    "_cgn_form_check_your_modem_id_label": "Om jouw type IP-adres (publiek of privé/CGN) te kennen, klik op de knop hieronder:",
    "_cgn_form_ask_ip_public_address_reasons_label": "Om een publiek adres <b>aan te vragen</b>, selecteer de reden(en) en klik vervolgens op de knop hieronder:",
    "_cgn_form_component_check_ip_label_button": "Mijn type IP-adres controleren",
    "_cgn_form_component_update_ip_label_button": "Mijn type IP-adres wijzigen",
    "_cgn_ip_policy_cgn": "De CGN is actief. U hebt een privé IPv4 adres.",
    "_cgn_ip_policy_public": "De CGN is niet actief, u hebt een IPv4 publiek adres.",
    "_cgn_ip_policy_error": "Oeps, we hebben een klein technisch probleem.  Gelieve later opnieuw te proberen",
    "_cgn_ip_policy_invalid": "Gelieve het MAC adres van de modem te controleren. Deze lijkt niet correct te zijn.",
    "_cgn_update_ip_policy_result_invalid":"Gelieve het MAC adres van de modem te controleren.  Deze lijkt niet correct te zijn.",
    "_cgn_update_ip_policy_result_error":"Oeps, we hebben een klein technisch probleem gelieve ons te contacteren via het nummer 5000.",
    "_cgn_update_ip_policy_result_success":"Uw aanvraag om CGN te verwijderen is verstuurd. U ontvangt een SMS om de modem te herstarten van zodra de aanvraag werwerkt is.",
    "_cgn_update_ip_policy_result_waiting":"Uw aanvraag om CGN te deactiveren is ontvangen. Een SMS zal verstuurd worden zodra uw aanvraag succesvol uitgevoerd is.",
    //--------------------

    // Page Activations
    "_ACTIVATIONS_INDEX_TITLE": "Activering van je TV Box(en)",
    "_ACTIVATIONS_INDEX_DESCRIPTION": "Gelieve ons de locatie van je nieuwe TV Box(en) mee te delen. Zo kunnen we je beter begeleiden als er een probleem is. " +
      "Je kan elke TV Box identificeren met behulp van het serienummer (Serial number 500xxxxxxxxx) op de sticker onderaan het toestel.",
    "_ACTIVATIONS_INDEX_CONFIRM_BUTTON": "Confirm",
    "_ACTIVATIONS_INDEX_ERROR_MISSING_DEVICE_LOCATION": "Gelieve ons de locatie van je nieuwe TV Box(en) mee te delen.",

    "_POST_ACTIVATE_CPE_SUCCESS": "Je TV Box(en) is/zijn geactiveerd. Je kan nu beginnen met de installatie",
    "_POST_ACTIVATE_CPE_GENERIC_ERROR": "Je TV Box(en) is/zijn niet geactiveerd. Probeer later opnieuw of neem contact op met de klantendienst.",

    // -------------------

    // User Hardware
    "Desktop": "Kantoor",
    "TV room": "Tv-kamer",
    "Living room": "Woonkamer",
    "Technical room": "Technische ruimte",
    "Kitchen": "Keuken",
    "Bedroom": "Slaapkamer",
    "Other": "Andere",
    "Garage street level": "Garage",
    "_HARDWARE_INDEX_SERIAL_NUMBER": "Serienummer",
    "_HARDWARE_INDEX_DEVICE_LOCATION": "Locatie",

    //--------------------

    // getPendingCpe errors
    "_GET_PENDING_CPE_ERROR_611": "We hebben geen dossier voor de activering van een TV Box gevonden. Dien je aanvraag in bij de klantendienst.",
    "_GET_PENDING_CPE_ERROR_612": "We hebben geen dossier voor de activering van een TV Box gevonden. Dien je aanvraag in bij de klantendienst.",
    "_GET_PENDING_CPE_ERROR_613": "Je TV Box(en) is/zijn niet geactiveerd. Probeer later opnieuw of neem contact op met de klantendienst.",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/nl.js